export const getMarket = () => {
    if (window.location.host.indexOf('.cz') !== -1) {
        return 'cz';
    } else if (window.location.host.indexOf('.sk') !== -1) {
        return 'sk';
    }

    return 'en';
};
